'use client';

import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';

interface SegmentedControlProps {
    options: { label: string; value: string }[];
    value: string;
    onChange: (value: string) => void;
}

export function SegmentedControl({ options, value, onChange }: SegmentedControlProps) {
    const { themeStyle } = useThemeContext();
    const bgColor = theme[themeStyle].secondaryBg;
    const textColor = theme[themeStyle].tag_white;

    const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: string | null) => {
        if (newValue !== null) {
            onChange(newValue);
        }
    };

    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={handleChange}
            size="small"
            sx={{
                borderRadius: 1,
                backgroundColor: bgColor,
                height: 40,
                px: 0.5,
                py: 0.5,
            }}>
            {options.map(option => (
                <ToggleButton
                    key={option.value}
                    value={option.value}
                    sx={{
                        px: 2,
                        py: 1,
                        textTransform: 'none',
                        fontSize: '0.875rem',
                        fontWeight: 500,
                        borderRadius: 1,
                        color: textColor,
                        border: 'none',
                        '&.Mui-selected': {
                            backgroundColor: textColor,
                            color: bgColor,
                            boxShadow: 1,
                        },
                        '&:hover': {
                            backgroundColor: themeStyle === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)',
                        },
                    }}>
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
